import { useFlag } from '../../hooks'

const useIsConsumerLendingIntroModalFlagEnabled = (): boolean => useFlag('consumer-portal-modal-lending-enabled', false)
export const useIsConsumerLendingIntroModalEnabled = (): boolean => useIsConsumerLendingIntroModalFlagEnabled()
